import React from 'react';
import { Form, Col, Row, Button, Spinner } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import axios from 'axios';
import moment from 'moment';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import GuestSiteMenu from "../guest_menu";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import '../../App.css';
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY h:mm A');
}

class ConciergeMain extends React.Component {

    constructor(props) {
        super(props);
        let userExists = !(props.location.state == null || props.location.state.user == null || Object.keys(props.location.state.user).length === 0);
        let historyExists = !(props.history.location.state == null || props.history.location.state.data == null)
        this.state = {
            user: userExists ? props.location.state.user : {},
            userExists: userExists,
            requestData: historyExists ? props.history.location.state.data : [],
            requestLoading: false,
            requestSelected: [],
            requestSelectedIds: [],
            unmappedData: historyExists ? props.history.location.state.data : [],
            requestLoading: false,
            unmappedSelected:[],
            unmappedSelectedIds: []
        };

        this.handleTableChange = this.handleTableChange.bind(this);

        this.requestLoadingSpinner = this.requestLoadingSpinner.bind(this);
        this.getRequests = this.getRequests.bind(this);
        this.unmappedLoadingSpinner = this.unmappedLoadingSpinner.bind(this);
        this.getUnmappedLocations = this.getUnmappedLocations.bind(this);
        this.handleRequestSelect = this.handleRequestSelect.bind(this);
        this.handleUnmappedSelect = this.handleUnmappedSelect.bind(this);


        this.handleViewRequest = this.handleViewRequest.bind(this);
        this.handleViewUnmapped = this.handleViewUnmapped.bind(this);
        //this.getCompletedTrainings = this.getCompletedTrainings.bind(this);

    }

    componentDidMount() {
        this.handleTableChange("search", this.state);
        this.getRequests();
        this.getUnmappedLocations();

    }

    requestLoadingSpinner() {
        if (this.state.requestLoading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No unhandled service requests.';
        }
    };

    unmappedLoadingSpinner() {
        if (this.state.unmappedLoading) {
            return <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>;
        }
        else {
            return 'No unmapped locations.';
        }
    };

    getRequests() {
        axios.get(`${Constants.apiURL}/api/Request/GetServiceRequests`, {
            params: {
                user: this.state.user.username
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    requestData: response.data,
                    requestLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }
    getUnmappedLocations() {
        axios.get(`${Constants.apiURL}/api/Request/GetUnmappedLocations`, {
            params: {
                user: this.state.user.username
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    unmappedData: response.data,
                    unmappedLoading: false
                }));
            }
        }).catch((response) => {
            if (response.response.status === 401) {
                this.props.history.push({
                    pathname: '/'
                });
            }
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ requestLoading: false });
            console.log('request failed', response)
        });
    }

    handleTableChange = (type, { }) => {
        this.setState({
            requestLoading: true,
            requestData: [],
            unmappedLoading: true,
            unmappedData: []
        },
            function () {
                this.getRequests();
                this.getUnmappedLocations();
            });
    }
    handleRequestSelect = (row, isSelect) => {
        let selected = [];
        if (isSelect) {
            selected = [row];
        } else {
            selected = this.state.requestSelected = [];
        }

        this.setState(() => ({
            requestSelected: selected,
            requestSelectedIds: selected.map(r => r.PortalServiceRequestKey)
        }));
    }
    handleUnmappedSelect = (row, isSelect) => {
        let selected = [];
        if (isSelect) {
            selected = [row];
        } else {
            selected = [];
        }
        console.log(row);

        this.setState(() => ({
            unmappedSelected: selected,
            unmappedSelectedIds: selected.map(r => r.DistinctId)
        }));
    }

    handleViewRequest() {

        this.props.history.push({
            pathname: '/view_service_request',
            state: {
                user: this.state.user,
                request: this.state.requestSelected[0]
            }
        });
    }
    handleViewUnmapped() {

        this.props.history.push({
            pathname: '/view_unmapped_location',
            state: {
                user: this.state.user,
                location: this.state.unmappedSelected[0]
            }
        });
    }

    render() {
        const requestColumns = [
            {
                text: 'ID',
                dataField: 'PortalServiceRequestKey',
                headerStyle: (colum, colIndex) => {
                    return { width: '60px', textAlign: 'left' };
                }
            },
            {
                text: 'Date Created',
                dataField: 'CreatedDate',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: '200px' };
                }
            },
            {
                text: 'Company',
                dataField: 'Company',
                headerStyle: (colum, colIndex) => {
                    return { width: '300px', textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Requestor First',
                dataField: 'RequestorFirstName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Requestor Last',
                dataField: 'RequestorLastName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Request Urgency',
                dataField: 'RequestUrgency',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: '180px', wordBreak: 'break-all' };
                }
            }];
        const unmappedColumns = [
            {
                text: 'Date Created',
                dataField: 'DateCreated',
                formatter: dateFormat,
                headerStyle: (colum, colIndex) => {
                    return { width: '170px', textAlign: 'left' };
                }
            },
            {
                text: 'Service Call ID',
                dataField: 'ServiceCallID',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: '150px' };
                }
            },
            {
                text: 'Location ID',
                dataField: 'LocationID',
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Location Name',
                dataField: 'LocationName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Customer ID',
                dataField: 'CustomerID',
                headerStyle: (colum, colIndex) => {
                    return { width: '140px', textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Customer Name',
                dataField: 'CustomerName',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', wordBreak: 'break-all' };
                }
            },
            {
                text: 'Address',
                dataField: 'Address1',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left',  wordBreak: 'break-all' };
                }
            },
            {
                text: 'State',
                dataField: 'State',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'left', width: '80px', wordBreak: 'break-all' };
                }
            }];
        const { requestData, unmappedData, requestSelected, unmappedSelected, requestSelectedIds, unmappedSelectedIds } = this.state;

        const selectRequestRow = {
            mode: 'radio',
            clickToSelect: true,
            onSelect: this.handleRequestSelect,
            hideSelectColumn: true,
            selected: requestSelectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        const selectUnmappedRow = {
            mode: 'radio',
            clickToSelect: true,
            onSelect: this.handleUnmappedSelect,
            hideSelectColumn: true,
            selected: unmappedSelectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };

        const customStyle = {
            padding: '10px',
            margin: '10px'
        };
        return (
            <div class="training_registration">
                {this.state.userExists ? <SiteMenu user={this.state.user} currentPage='conciergeMain' /> : <GuestSiteMenu currentPage='conciergeMain' />}
                <Form onSubmit={this.handleSearch}  className="mb-3">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'fit-content' }}>SERVICE REQUEST QUEUE</Form.Label>
                        </Col>
                    </Form.Group>
                </Form>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="PortalServiceRequestKey"
                    data={requestData}
                    columns={requestColumns}
                    selectRow={selectRequestRow}
                    striped
                    hover
                    noDataIndication={this.requestLoadingSpinner}
                    loading={this.state.requestLoading}
                    style={customStyle}
                    onTableChange={this.handleTableChange}
                />
                <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 10px 10px', marginRight: 0 }}>
                    <Col md="auto" sm="auto" xs="auto">
                        <Button disabled={requestSelected.length == 0} style={{ backgroundColor: '#00973A', marginRight: '10px' }} variant="primary" type="submit" onClick={this.handleViewRequest}>
                            View Request
                        </Button>
                    </Col>
                </Form.Group>
                <Form onSubmit={this.handleSearch} className="mb-3">

                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 10px 0px 10px' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ paddingBottom: 0, marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: '21px', color: '#1F419B', width: 'fit-content' }}>LOCATION/BUILDING MAPPING</Form.Label>
                        </Col>
                    </Form.Group>
                </Form>
                <BootstrapTable
                    bootstrap4
                    remote
                    keyField="DistinctId"
                    data={unmappedData}
                    columns={unmappedColumns}
                    selectRow={selectUnmappedRow}
                    striped
                    hover
                    noDataIndication={this.unmappedLoadingSpinner}
                    loading={this.state.unmappedLoading}
                    style={customStyle}
                    onTableChange={this.handleTableChange}
                />
                <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 10px 10px', marginRight: 0 }}>
                    <Col md="auto" sm="auto" xs="auto">
                        <Button disabled={unmappedSelected.length == 0} style={{ backgroundColor: '#00973A', marginRight: '10px' }} variant="primary" type="submit" onClick={this.handleViewUnmapped}>
                            View Unmapped Location
                        </Button>
                    </Col>
                </Form.Group>
            </div>
        );
    }
}

export default ConciergeMain;